var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "field is-horizontal" }, [
    _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label", attrs: { for: "bodymass" } }, [
        _vm._v(_vm._s(_vm.label ?? "Bodyweight")),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field-body" }, [
      _c(
        "div",
        { staticClass: "field has-addons" },
        [
          _c("div", { staticClass: "control is-expanded" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.quantity,
                  expression: "quantity",
                },
              ],
              staticClass: "input",
              attrs: {
                type: "number",
                id: "bodymass",
                name: "bodymass",
                required: _vm.required,
                min: "5",
                max: "400",
                step: _vm.bodyMassViewModel.step,
              },
              domProps: { value: _vm.quantity },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.quantity = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("span", { staticClass: "button is-static" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.bodyMassViewModel.symbol) +
                  "\n          "
              ),
              _c("input", {
                attrs: { type: "hidden", name: "bodymassunit" },
                domProps: { value: _vm.bodyMassViewModel.symbol },
              }),
            ]),
          ]),
          _vm._v(" "),
          _vm.bodyMassViewModel.symbol === "st"
            ? [
                _c("div", { staticClass: "control is-expanded" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.remainderQuantity,
                        expression: "remainderQuantity",
                      },
                    ],
                    staticClass: "input",
                    attrs: {
                      type: "number",
                      id: "bodymass_minor",
                      name: "bodymass_minor",
                      min: "0",
                      max: "13.5",
                      step: "0.5",
                    },
                    domProps: { value: _vm.remainderQuantity },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.remainderQuantity = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("span", { staticClass: "button is-static" }, [
                    _vm._v(
                      "\n                  " +
                        _vm._s(_vm.bodyMassViewModel.remainderSymbol) +
                        "\n                "
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }